(
    function (/** @type {GlobalSkyward} */ skyward, $, undefined)
    {
        "use strict";
        skyward.importColumnViewer = skyward.importColumnViewer || {};

    var initImportColumnViewer = function (selector)
    {
        var importColumnViewer = $(selector + " .importColumnViewer");
        var columnsHidden = $(selector + " .columnsHidden ");
        var changeTracker = skyward.changeTracking.getChangeTracker(importColumnViewer);

        var updateTableHiddenValue = function ()
        {
            var originalValue = JSON.stringify(columnsHidden.data().originalvalue);
            var newValue = [];
            importColumnViewer.find(".importColumnRow.bodyRow .columnJSON ").each(function ()
            {
                newValue.push(JSON.parse($(this).val()));
            });

            newValue = JSON.stringify(newValue);

            if (newValue !== originalValue)
            {
                skyward.dataobjectviewer.enableButtons("editImportColumns");
                changeTracker.overrideDirtyState(true);
            }
            else
            {
                skyward.dataobjectviewer.disableButtons("editImportColumns");
                changeTracker.overrideDirtyState(false);
            }

            columnsHidden.val(newValue);
        };

        var editColumnCrossReferenceTable = function ()
        {
            var columnCrossReferenceTableInUse = $(this).closest(".importColumnRow.bodyRow").find(".columnCrossReferenceTableInUse ");
            var columnRowHidden = $(this).closest(".importColumnRow.bodyRow").find(".columnJSON ");
            var columnJSON = columnRowHidden.val();
            var columnObject = JSON.parse(columnJSON);

            var updateRowHiddenValue = function (newValue)
            {
                columnObject = newValue;

                columnRowHidden.val(JSON.stringify(columnObject));
                updateTableHiddenValue();

                columnCrossReferenceTableInUse.prop('checked', !$.isEmptyObject(columnObject.LookupTable));
            };

            skyward.crossReferenceTableEditor.launch({ columnParser: columnJSON, callback: updateRowHiddenValue });
        };

        importColumnViewer.find(".editColumnCrossReferenceTable").on("click", editColumnCrossReferenceTable);
    };

    skyward.window.registerLoadDOMCallback(initImportColumnViewer);
}(window.skyward = window.skyward || {}, window.jQuery)
);